import MenuBookIcon from '@mui/icons-material/MenuBook';
import EventIcon from '@mui/icons-material/Event';
import TvIcon from '@mui/icons-material/Tv';
import LocalMoviesIcon from '@mui/icons-material/LocalMovies';
import PhotoCameraIcon from '@mui/icons-material/PhotoCamera';
import CategoryIcon from '@mui/icons-material/Category';
import PeopleIcon from '@mui/icons-material/People';
import PlaceIcon from '@mui/icons-material/Place';
import PsychologyIcon from '@mui/icons-material/Psychology';
import VideogameAssetIcon from '@mui/icons-material/VideogameAsset';
import MusicNoteIcon from '@mui/icons-material/MusicNote';
import RestaurantIcon from '@mui/icons-material/Restaurant';
import { Avatar, Box, Tooltip, Typography } from '@mui/material';
import { formatLabel } from '../utils/itemUtil';

const TagIcons = {
    'books': MenuBookIcon,
    'events': EventIcon,
    'movies': LocalMoviesIcon,
    'music': MusicNoteIcon,
    'albums': MusicNoteIcon,
    'people': PeopleIcon,
    'places': PlaceIcon,
    'pictures': PhotoCameraIcon,
    'restaurants': RestaurantIcon,
    'shows': TvIcon,
    'thoughts': PsychologyIcon,
    'video games': VideogameAssetIcon,
};

const normalize = name => String(name || '').toLowerCase().replace(/_/g, ' ').trim();

// Unknown categories get a generic icon rather than missing content.
export const getTagIconComponent = name => TagIcons[normalize(name)] || CategoryIcon;

export const GetTagIcon = name => {
    const Icon = getTagIconComponent(name);
    return <Icon />;
}

export const TagIcon = ({ name }) => {
    return (
        <Tooltip title={formatLabel(name)}>
            <Avatar sx={{ width: '32px', height: '32px', bgcolor: 'sage.surface', color: 'sage.text' }}>
                {GetTagIcon(name)}
            </Avatar>
        </Tooltip>
    );
}

// Bare sage icon, used beside uppercase category labels.
export const TagTypeIcon = ({ name, sx = {}, ...props }) => {
    const Icon = getTagIconComponent(name);
    return <Icon aria-hidden="true" sx={{ color: 'sage.main', fontSize: 16, ...sx }} {...props} />;
}

// Type icon next to an uppercase category label ("BOOKS").
export const TypeLabel = ({ name, sx = {} }) => {
    return (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: '7px', minWidth: 0, ...sx }}>
            <TagTypeIcon name={name} />
            <Typography
                component="span"
                variant="overline"
                sx={{ color: 'text.secondary', textTransform: 'uppercase', overflowWrap: 'anywhere' }}
            >
                {formatLabel(name) || 'Item'}
            </Typography>
        </Box>
    );
}
